export default {"src":"/_next/static/media/mercator.10448f26.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};